import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const Ctx = createContext({});
let cache = null;

export function FormulaProvider({ children }) {
  const [map, setMap] = useState(cache || {});
  useEffect(() => {
    if (cache) return;
    api.get("/lexique").then(r => { cache = Object.fromEntries((r.data.items || []).map(i => [i.key, i])); setMap(cache); }).catch(() => {});
  }, []);
  return <Ctx.Provider value={map}>{children}</Ctx.Provider>;
}

export function FormulaTip({ k, testid }) {
  const map = useContext(Ctx); const e = map[k];
  if (!e) return null;
  return (
    <span className="relative group inline-flex shrink-0" data-testid={testid || `formula-${k}`}>
      <span className="w-4 h-4 rounded-full bg-slate-100 text-slate-500 text-[10px] font-bold italic grid place-items-center cursor-help group-hover:bg-orange-100 group-hover:text-orange-700" style={{ fontFamily: "Georgia, serif" }}>ƒ</span>
      <span className="pointer-events-none absolute z-50 left-1/2 -translate-x-1/2 top-6 w-64 rounded-xl border border-slate-200 bg-white p-2.5 text-left shadow-xl opacity-0 group-hover:opacity-100 transition-opacity" role="tooltip">
        <span className="block text-[11px] font-bold text-slate-900">{e.name}</span>
        <span className="block mt-1 text-[10px] font-mono text-orange-700 bg-orange-50 rounded px-1.5 py-1">{e.formula}</span>
        <span className="block mt-1 text-[10px] text-slate-500 leading-snug">{e.description}</span>
        {e.source && <span className="block mt-1 text-[9px] text-slate-400">Source : {e.source}</span>}
      </span>
    </span>
  );
}
